import React from "react";
import { motion } from "framer-motion";
import "./Home.css";
import {
  one,
  two,
  three,
  four,
  five,
  six,
  seven,
  eight,
  nine,
  ten,
  eleven,
  twelve,
  thirteen,
  fourteen
} from "../../../assets/image.js";

import { LiaPrayingHandsSolid } from "react-icons/lia";
import { BsWhatsapp } from "react-icons/bs";
import { IoMdCall } from "react-icons/io";
import { FaInstagram } from "react-icons/fa6";
import { IoLocationSharp } from "react-icons/io5";

const Home = ({ contactSectionRef }) => {

  

  return (
    <>
      <div className="home-bg">
        {/* First Section with Text and Image */}
        <motion.div
          className="home-content"
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: "easeOut" }}
        >
          <motion.h1
            className="home-heading"
            initial={{ opacity: 0, y: -30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, ease: "easeOut" }}
          >
            खम्मा घणी <LiaPrayingHandsSolid />
          </motion.h1>

          <motion.p
            className="home-description"
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1.2, delay: 0.5, ease: "easeOut" }}
          >
            A Cafe with a mesmerising view of 2 Lakes. <br />
            Since 1982. <br />
            Come for the coffee, stay for the view.
          </motion.p>

          <motion.div
            className="image-container"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1.5, delay: 1, ease: "easeOut" }}
          >
            <img src={one} alt="Cafe" className="responsive-image" />
          </motion.div>
        </motion.div>

        {/* Horizontal Line */}
        <motion.hr
          className="divider"
          initial={{ width: "0%" }}
          animate={{ width: "80%" }}
          transition={{ duration: 1.2, delay: 1.5, ease: "easeOut" }}
        />

        {/* Second Section with Text and Images */}
        <motion.div
          className="views-section"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.2, delay: 2, ease: "easeOut" }}
        >
          <motion.div
            className="text-section"
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1.2, delay: 2.5, ease: "easeOut" }}
          >
            <h2>Evenings with Magical Sunsets</h2>
            <p>
              Experience breathtaking sunsets and stunning views at Cafe Hill
              Park. Perfect for a relaxing evening by the lake.
            </p>
          </motion.div>

          <div className="images-grid">
            <motion.img
              src={two}
              alt="Sunset view"
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 1.2, delay: 2.8, ease: "easeOut" }}
            />
            <motion.img
              src={three}
              alt="Cafe view"
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 1.2, delay: 3, ease: "easeOut" }}
            />
            <motion.img
              src={four}
              alt="Evening view"
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 1.2, delay: 3.2, ease: "easeOut" }}
            />
            <motion.img
              src={five}
              alt="Lake view"
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 1.2, delay: 3.4, ease: "easeOut" }}
            />
          </div>
        </motion.div>

         {/* New Section with Text and Images */}
         <motion.hr
          className="divider"
          initial={{ width: "0%" }}
          animate={{ width: "80%" }}
          transition={{ duration: 1.2, delay: 4, ease: "easeOut" }}
        />

        <motion.div
          className="views-section"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.2, delay: 4.5, ease: "easeOut" }}
        >
          <motion.div
            className="text-section"
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1.2, delay: 5, ease: "easeOut" }}
          >
            <h2>Book Your Special Day with Us</h2>
            <p>
              Celebrate your special occasions with a stunning backdrop of nature. <br />
              Host private parties, events, and more, while enjoying the serene lakeside views.
            </p>
          </motion.div>

          <div className="images-grid">
            {/* Alternating Large and Normal Images */}
            <motion.img
              src={six}
              alt="Event view"
              className="large"
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 1.2, delay: 5.2, ease: "easeOut" }}
            />
            <motion.img
              src={seven}
              alt="Wedding view"
              className="normal"
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 1.2, delay: 5.4, ease: "easeOut" }}
            />
            <motion.img
              src={eight}
              alt="Party view"
              className="normal"
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 1.2, delay: 5.6, ease: "easeOut" }}
            />
            <motion.img
              src={nine}
              alt="Evening Party"
              className="large"
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 1.2, delay: 5.8, ease: "easeOut" }}
            />
            <motion.img
              src={ten}
              alt="Outdoor view"
              className="large"
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 1.2, delay: 6, ease: "easeOut" }}
            />
          </div>
        </motion.div>

        {/* New Section: Nature and Coffee View */}
        <motion.hr
          className="divider"
          initial={{ width: "0%" }}
          animate={{ width: "80%" }}
          transition={{ duration: 1.2, delay: 4, ease: "easeOut" }}
        />

        <motion.div
          className="views-section"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.2, delay: 4.5, ease: "easeOut" }}
        >
          <motion.div
            className="text-section"
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1.2, delay: 5, ease: "easeOut" }}
          >
            <h2>Relax with Nature</h2>
            <p>
              Come for the coffee, stay for the view. Enjoy a serene atmosphere
              surrounded by the beauty of nature, lakes, and green spaces. The
              perfect spot to unwind and refresh your mind.
            </p>
          </motion.div>

          <div className="images-grid">
            <motion.img
              src={eleven}
              alt="Nature view"
              className="large"
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 1.2, delay: 5.2, ease: "easeOut" }}
            />
            <motion.img
              src={fourteen}
              alt="Scenic view"
              className="normal"
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 1.2, delay: 5.4, ease: "easeOut" }}
            />
            
            <motion.img
              src={thirteen}
              alt="Greenery view"
              className="large"
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 1.2, delay: 5.8, ease: "easeOut" }}
            />
         
          </div>
        </motion.div>

        {/*  */}
      </div>

      {/* Contact and About Section */}
      <motion.div
        className="contact-section"
        ref={contactSectionRef}
        initial={{ opacity: 0, y: 100 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1.5, delay: 4 }}
      >
        <div className="contact-left">
          <div className="contact-icons">
            <a
              href="https://wa.me/918387884229"
              target="_blank"
              rel="noopener noreferrer"
            >
              <BsWhatsapp />
            </a>
            <a href="tel:+918387884229">
              <IoMdCall />
            </a>
            <a
              href="https://www.instagram.com/cafe_hillpark?igsh=MTMxdWx1Z29ndXRpdQ=="
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaInstagram />
            </a>
          </div>
          <p>Contact for more</p>
        </div>

        <div className="vertical-line"></div>

        <div className="contact-right">
          <IoLocationSharp />
          <p>
            Cafe Hill Park, Manik Lal Verma Park, <br />
            Karni Mata, Doodh Talai, Udaipur
          </p>
          <a
            href="https://maps.app.goo.gl/gFCtrXWZv5PrfjgL6"
            target="_blank"
            rel="noopener noreferrer"
          >
            View Location
          </a>
        </div>
      </motion.div>
    </>
  );
};

export default Home;
